export default [
  {
    name: 'Randy Weiner',
    title: 'CEO',
    image: `${process.env.PUBLIC_URL}/assets/img/team/rweiner.jpg`,
    description: `Randy has worked in start-ups, education, and education
    technology for the past 20 years. Expert in agile development, Randy is
    also a co-founder and the Chairman of the Board at Urban Montessori
    Charter School in Oakland, CA, the nation’s first public Montessori, Arts
    Integration and Design Thinking school. A Teach For America alum, he
    taught for five years in Oakland and Madagascar and holds B.A.s from
    Middlebury College and an MA in Education from Stanford University.`,
  },
  {
    name: 'Pamela Briskman',
    title: 'Chief Learning Officer',
    image: `${process.env.PUBLIC_URL}/assets/img/team/pbriskman.jpg`,
    description: `Pamela is a math education evangelist with 20+ years’
    experience at the intersection of curriculum, design, and technology.
    She’s a Teach For America alum who’s taught in Oakland, CA and
    Antananarivo, Madagascar with degrees in Product Design Engineering and
    Studio Art from Stanford. Pamela has designed math curriculum for
    NSF-funded programs and award-winning educational television, toys,
    games, and video games. She is a co-founder of Urban Montessori Charter
    School.`,
  },
  {
    name: 'Keith Devlin',
    title: 'Chief Scientist',
    image: `${process.env.PUBLIC_URL}/assets/img/team/kdevlin.jpg`,
    description: `A world famous Stanford mathematician and the NPR “Math
    Guy,” Dr. Keith Devlin’s eight-year study of video games’ potential in
    math education resulted in the first book on the subject, Mathematics
    Education for a New Era. He has a B.Sc. in Mathematics from Kings College
    London and a Ph.D. in Mathematics from the University of Bristol. He has
    published 32 books and many research articles. His honors include the
    Pythagoras Prize, the Peano Prize, and the Carl Sagan Award.`,
  },
  {
    name: 'Steve Mays',
    title: 'CTO',
    image: `${process.env.PUBLIC_URL}/assets/img/team/smays.png`,
    description: `Steve has over 25 years' experience building large-scale
    systems and companies for the film/FX, video gaming, internet, medical
    and advertising industries. He’s served as an advisor on Electronic
    Governance for the US government, was interim CEO of Sierra Online, and
    built supercomputers for Industrial Light and Magic. Steve founded and
    ran his own companies who consulted to Kaiser Permanente, Sony (Japan),
    McKesson, Twitter, and Audi (North America). `,
  },
  {
    name: 'Michael Romero',
    title: 'Lead Engineer',
    image: `${process.env.PUBLIC_URL}/assets/img/team/mromero.jpg`,
    description: `Michael is an experienced game programmer who has worked in
    a variety of spaces including MMO, Social and Indie. After working for
    game companies such as Slipgate Ironworks, Smith & Tinker, and The
    Amazing Society, he now brings his expertise to BrainQuake to help
    deliver a premium experience in all BrainQuake gaming offerings.`,
  },
];
